import { publicOfferHTML } from '@webapp/landing/src/components/ru/docs/html/public-offer';

import { Doc } from './doc';

export const PublicOffer: FC = () => <Doc html={publicOfferHTML} title='Оферта' />;
